// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlidersFilledSvg from "@fishx/icons-svg/es/asn/SlidersFilled";
import FishxIcon from '../components/FishxIcon';

var SlidersFilled = function SlidersFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlidersFilledSvg
  }));
};

SlidersFilled.displayName = 'SlidersFilled';
export default React.forwardRef(SlidersFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SlidersFilled.js
// module id = 4143
// module chunks = 0